/**
 * PlayerLanguageModalContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled player language modal container.
 */
const PlayerLanguageModalContainer = styled.div<{ hideBackground?: boolean }>`
  background: ${(props) =>
    props.hideBackground ? '' : Colors['modal']['background']};
  display: flex;
  height: 100vh;
  left: ${148 * Screen.widthRatio}px;
  position: fixed;
  top: 0;
  width: ${600 * Screen.widthRatio}px;
  z-index: 175; // Above pause ad, pilot and player. Below ads
`;

export default PlayerLanguageModalContainer;
